import { inject, Injectable } from '@angular/core'
import { CanActivate, CanActivateChild, GuardResult, MaybeAsync, Router } from '@angular/router'

@Injectable({
	providedIn: 'root',
})
export class SingleTabGuard implements CanActivate, CanActivateChild {
	private readonly _router: Router = inject<Router>(Router)

	private _channel: BroadcastChannel = new BroadcastChannel('single-tab-channel')

	private _canRedirect(): boolean {
		this._channel.postMessage('single-tab')

		this._channel.onmessage = (): boolean => {
			this._router.navigate(['single-tab'])
			return false
		}

		return true
	}

	canActivate(): MaybeAsync<GuardResult> {
		return this._canRedirect()
	}

	canActivateChild(): MaybeAsync<GuardResult> {
		return this.canActivate()
	}
}
